import createLucideIcon from '../createLucideIcon';

const MonitorSpeaker = createLucideIcon('MonitorSpeaker', [
  ['path', { d: 'M5.5 20H8', key: '1k40s5' }],
  ['path', { d: 'M17 9h.01', key: '1j24nn' }],
  [
    'rect',
    { width: '10', height: '16', x: '12', y: '4', rx: '2', key: 'ixliua' },
  ],
  ['path', { d: 'M8 6H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4', key: '1mp6e1' }],
  ['circle', { cx: '17', cy: '15', r: '1', key: 'tqvash' }],
]);

export default MonitorSpeaker;
